import { useMutation, useQueryClient } from "@tanstack/react-query";
import { terminalInventoryKeys } from "Api/Queries/TerminalInventory/useTerminalInventoryListQuery";
import { deleteTerminalInventoryPublicID } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useDeleteTerminalInventoryItemMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails((publicID: string) =>
      deleteTerminalInventoryPublicID(publicID),
    ),
    onSuccess: () => {
      // Only the lists — invalidating the root key would refetch the deleted
      // terminal's still-mounted audit query and 404 before the dialog closes.
      queryClient.invalidateQueries({
        queryKey: terminalInventoryKeys.lists(),
      });
      onSuccess?.();
    },
    onError,
  });
};
